module.exports = __webpack_public_path__ + "static/media/2.e1542993.jpg";